import React from "react";
import { FaRegThumbsUp, FaRegThumbsDown } from "react-icons/fa";
import { MdOutlineCategory, MdTimer } from "react-icons/md";
import { RWebShare } from "react-web-share";
import { AiFillPlusCircle } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import '../styles/Card.css';
import prof from '../images/aayush.png'
import { GrShareOption } from "react-icons/gr";

const NewsCard = ({
  post,
  onLike,
  onDislike,
  likesCount,
  dislikesCount,
  timeDifference,
  profileimg,
  postimg,
}) => {
  const navigate = useNavigate();

  return (
    <div className="my-2" onClick={()=> navigate(`${post._id}`)}>
    <div className="flex flex-col items-start p-6  bg-white border-2 rounded-xl mx-4 ">
      <div className="flex w-full items-start gap-2.5">
        <div className="media flex items-center gap-2.5">
          <div className="media-body w-full flex justify-between items-center gap-x-1">
            <div className="flex justify-center items-center p-0.5 p-0 rounded-full">
              <img
                src={prof}
                className="lightgray 50% / cover no-repeat w-[3.75rem] h-[3.75rem] rounded-full"
                alt="Profile"
              />
            </div>
            <div className="flex flex-col items-start media-content">
              <div className="flex items-center gap-2.5 self-stretch">
                <div className="aayush_talreja text-black font-['Roboto'] font-medium leading-6">
                  Aayush Talreja
                </div>
                <div className="flex items-start gap-2.5 w-[0.9375rem] h-[0.9375rem]">
                  <svg
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.5 0C3.35795 0 0 3.35795 0 7.5C0 11.642 3.35795 15 7.5 15C11.642 15 15 11.642 15 7.5C15 3.35795 11.642 0 7.5 0ZM10.7509 6.23182C10.8108 6.16339 10.8563 6.08369 10.8849 5.99739C10.9135 5.91109 10.9246 5.81994 10.9175 5.72931C10.9103 5.63867 10.8851 5.55038 10.8433 5.46963C10.8016 5.38888 10.7441 5.3173 10.6742 5.2591C10.6044 5.20089 10.5236 5.15725 10.4367 5.13072C10.3497 5.1042 10.2583 5.09534 10.1679 5.10466C10.0774 5.11397 9.98978 5.14128 9.91005 5.18498C9.83033 5.22867 9.76015 5.28787 9.70364 5.35909L6.77182 8.87659L5.25477 7.35886C5.12618 7.23467 4.95395 7.16594 4.77518 7.1675C4.59641 7.16905 4.4254 7.24075 4.29899 7.36717C4.17257 7.49358 4.10087 7.66459 4.09931 7.84336C4.09776 8.02213 4.16648 8.19436 4.29068 8.32295L6.33614 10.3684C6.40313 10.4354 6.48334 10.4876 6.57165 10.5219C6.65996 10.5561 6.75443 10.5716 6.84905 10.5673C6.94366 10.563 7.03635 10.539 7.12119 10.4969C7.20603 10.4548 7.28117 10.3955 7.34182 10.3227L10.7509 6.23182Z"
                      fill="#1236F3"
                    />
                  </svg>
                </div>
              </div>
              <div className="mumbai__india self-stretch text-[#6c757d] font-['Roboto'] text-sm leading-1">
                Mumbai, India
              </div>
            </div>
            <RWebShare data={{
                  text: `🔴 ${post.title} \n\n ${post.description} \n\n Source: 💧 Jal Suraksha`,
                  url: `https://jal-suraksha.vercel.app/posts/${post._id}`,
                  title: `${post.title} (${post.city}) - Jal Suraksha`,
                }}
                onClick={() =>
                  console.log("News shared successfully!")
                }
              >
                <button className="flex items-center justify-center text-white bg-white font-bold py-2 pl-4 hover:bg-[#0d212e] rounded-xl w-1/3 h-10 my-4 cursor-pointer transition-all px-6 border-blue-400 border-b-[4px] hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px] active:border-b-[2px] active:brightness-90 active:translate-y-[2px] hover:shadow-lg hover:shadow-blue-600 shadow-blue-800 active:shadow-none">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <GrShareOption size={25} className="invert" />
                  </div>
                </button>
              </RWebShare>
          </div>
        </div>
      </div>
      <div className="flex items-start gap-2.5 self-stretch py-6 text-black font-['Roboto'] text-2xl font-bold leading-[130%]">
        {post.title}
      </div>
      <div className="flex items-center self-stretch justify-center">
        <img
          src={postimg}
          className="unsplash_z9qoq6d_mkg lightgray 50% / no-repeat h-[12.625rem] rounded-lg"
          alt="Post"
        />
      </div>
      <div className="july_17__2018 self-stretch text-[#6c757d] font-['Roboto'] text-sm my-2 leading-5">
        {timeDifference[post._id] || "just now"}
      </div>
      <div className="flex flex-col mx-0 text-start justify-start gap-2.5 self-stretch p-2 lorem_ipsum_dolor_sit_amet__consectetur_adipiscing_elit__sed_do_eiusmod_tempor_incididunt_ut_labore_et_dolore_magna_aliqua_ self-stretch text-black font-['Roboto'] leading-[1.4375rem]">
        {post.description}
      </div>
      <div className="flex justify-center items-center gap-2.5 self-stretch p-2.5 p-2 rounded-lg bg-gray-50 report_an_issue text-black font-['Roboto'] text-sm leading-5">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
          <path
            fill="#737373"
            d="M12 17q.425 0 .713-.288T13 16q0-.425-.288-.712T12 15q-.425 0-.712.288T11 16q0 .425.288.713T12 17Zm0-4q.425 0 .713-.288T13 12V8q0-.425-.288-.712T12 7q-.425 0-.712.288T11 8v4q0 .425.288.713T12 13Zm-2.925 8q-.4 0-.762-.15t-.638-.425l-4.1-4.1q-.275-.275-.425-.638T3 14.926v-5.85q0-.4.15-.762t.425-.638l4.1-4.1q.275-.275.638-.425T9.075 3h5.85q.4 0 .763.15t.637.425l4.1 4.1q.275.275.425.638t.15.762v5.85q0 .4-.15.763t-.425.637l-4.1 4.1q-.275.275-.638.425t-.762.15h-5.85Zm.025-2h5.8l4.1-4.1V9.1L14.9 5H9.1L5 9.1v5.8L9.1 19Zm2.9-7Z"
          />
        </svg>
        Report an Issue
      </div>
    </div>
    </div>
  );
};

export default NewsCard;
